import TableSkeleton from '../TableSkeleton/TableSkeleton'

import './QueryResultSkeleton.css'

export default function QueryResultSkeleton() {
  return (
    <section id="query-result" className="query-result-skeleton skeleton-mode">
      <h2>
        <div className="skeleton-pulse value" />
      </h2>
      <div id="query-result-info">
        <TableSkeleton />
      </div>
    </section>
  )
}
